import { Typography } from 'Components/Typography';

import Button from './MembershipPercsButton';
import MembershipPercsCard from './MembershipPercsCard';

export const PodcastPercsCard = () => (
  <MembershipPercsCard>
    <div>
      <Typography paragraph variant="h3">
        Listen to Prose in Practice
      </Typography>
      <Typography paragraph variant="p3">
        A five-part guided series exploring the essential steps of self-care, from hair to mind and
        body, to transform your daily routine into a personal ritual all your own.{' '}
      </Typography>
    </div>
    <Button
      Component="a"
      data-click="podcast"
      data-from="membership-lp-subscribers"
      href="https://podcasts.apple.com/us/podcast/prose-in-practice/id1518324177"
      rel="noopener noreferrer"
      target="_blank"
      variant="lime"
    >
      listen on apple podcasts
    </Button>
    <Button
      Component="a"
      data-click="podcast"
      data-from="membership-lp-subscribers"
      href="https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5tZWdhcGhvbmUuZm0vQ0FENjc0MzM1MTMzMQ?ved=2ahUKEwjVzcGOkpjqAhUmn3IEHcmdAykQ4aUDegQIARAC&hl=en"
      rel="noopener noreferrer"
      target="_blank"
      variant="lime"
    >
      listen on google podcasts
    </Button>
    <Button
      Component="a"
      data-click="podcast"
      data-from="membership-lp-subscribers"
      href="https://open.spotify.com/show/42pIGPtRQyEETIcTojLKk3?si=DUrc1P4xRqWhIdIRUqNU9w"
      rel="noopener noreferrer"
      target="_blank"
      variant="lime"
    >
      listen on spotify
    </Button>
  </MembershipPercsCard>
);

export const ProductTestingPercsCard = () => (
  <MembershipPercsCard>
    <div>
      <Typography paragraph variant="h3">
        New product testing
      </Typography>
      <Typography paragraph variant="p3">
        From time to time, we’ll email you with new opportunities to try unreleased products still
        in development
      </Typography>
    </div>
    <Button
      data-click="new-products-enroll"
      data-from="membership-lp-subscribers"
      disabled
      variant="lime"
    >
      Check Back Later
    </Button>
  </MembershipPercsCard>
);
